import React from 'react';
import I18n from 'i18n-js';
import { csvDataUri } from '@/utils/csv';
import { FrameworkNoun, StudentScores, Tag } from './types';

interface ExportCsvLinkProps {
  frameworkNoun: FrameworkNoun;
  students: StudentScores[];
  tags: Tag[];
}

const ExportCsvLink = ({ frameworkNoun, students, tags }: ExportCsvLinkProps) => {
  const rows = [
    [I18n.t('student'), ...tags.map(tag => tag.alias)],
    ...students.map(student => [student.name, ...student.scores.map(score => score ?? '-')]),
  ];

  return (
    <a
      className="btn btn--outline-purple tw-ml-2"
      download={`${frameworkNoun.toLowerCase()}.csv`}
      href={csvDataUri(rows)}
    >
      {I18n.t('export_csv')}
    </a>
  );
};

export default ExportCsvLink;
